import { Component, EventEmitter, Output } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedModalDataType } from "../modal-service.service";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-modal-error",
  templateUrl: "./modal-error.component.html",
  styleUrls: ["./modal-error.component.css"],
})
export class ModalErrorComponent {
  data: SharedModalDataType<any> = {
    title: "Missing Title Parameter",
    body: "Default Body",
  };
  @Output() pressedConfirm = new EventEmitter<void>();
  @Output() pressedCancel = new EventEmitter<void>();

  faTriangleExclamation = faTriangleExclamation;

  constructor(public activeModal: NgbActiveModal) {}

  // Resto del código del componente

  confirm() {
    this.pressedConfirm.emit();
  }

  cancel() {
    this.pressedCancel.emit();
  }
}
